setTimeout(function () {
    var galleryThumb = new Swiper("#gallery-thumb", {
        lazy: {
            loadPrevNext: true,
        },
        observer:true,
        observeParents:true,
        observeSlideChildren:true,
        spaceBetween: 5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    var galleryMain = new Swiper("#gallery-main", {
        lazy: {
            loadPrevNext: true,
        },
        spaceBetween:0,
        observer:true,
        observeParents:true,
        observeSlideChildren:true,
        autoplay:true,
        thumbs: {
            swiper: galleryThumb,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
},70);


window.onload = function () {
    'use strict';
    var Viewer = window.Viewer;
    var pictures = document.querySelector('.viewer-pictures');
    var options = {
        url: 'data-original',
        title:[1, (image,imageData) => `${image.alt} (${imageData.naturalWidth} × ${imageData.naturalHeight})`]
    };
    var viewer = new Viewer(pictures, options);
};

let attributeLists = $('.attribute-box .item');
for (var i = 0; i < attributeLists.length; i++) {
    if (i > 14) {
        $(attributeLists[i]).hide();
    }
}
$('.attribute-more-btn').on({
    click: function () {
        let textTitle = $(this).children('.text-title');
        let iconfont = $(this).children('.iconfont');
        let mask = $(this).siblings('.attribute-mask');
        if (textTitle.html() == '展开') {
            textTitle.html('收起');
            iconfont.removeClass('icon-more-down').addClass('icon-more-up');
            $('.attribute-box .item').slideDown(300);
            mask.hide(300);
        }else {
            textTitle.html('展开');
            iconfont.removeClass('icon-more-up').addClass('icon-more-down');
            for(var i=0;i<attributeLists.length;i++) {
                if(i>14){
                    $(attributeLists[i]).slideUp(300);
                    mask.show(300);
                }
            }
        }
    }
})












